export const LOGIN_USER = "LOGINUSER"
export const logInUser = user => ({
  type: LOGIN_USER,
  payload: user
})

export const LOG_OUT_USER = "LOGOUTUSER"
export const logOutUser = () => ({
  type: LOG_OUT_USER
})
